// Copyright 2025 Immersive Technologies Pty Ltd. All rights reserved.

export const EMAIL_SENDER = 'no-reply@immersivetechnologies.cloud';
